export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL
export const SENTRY_PUBLIC_KEY = process.env.REACT_APP_SENTRY_PUBLIC_KEY
export const SENTRY_PROJECT_ID = process.env.REACT_APP_SENTRY_PROJECT_ID